import {IDischargeCurveSettings} from './curve.controller';

export class DischargeCurveSettingsDialog {
  static $inject = ['$mdDialog'];

  curveSettings:IDischargeCurveSettings;

  constructor(private $mdDialog:ng.material.IDialogService) {
  }

  get manualViewport() {
    return !this.curveSettings.fitViewportToData;
  }

  set manualViewport(value:boolean) {
    this.curveSettings.fitViewportToData = !value;
  }

  apply = () => {
    this.$mdDialog.hide(this.curveSettings);
  };

  cancel = () => {
    this.$mdDialog.cancel();
  }
}



/** WEBPACK FOOTER **
 ** ./app/discharge/curve-settings-dialog.controller.ts
 **/